import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'HomeM',
        // import(/* webpackChunkName: "home" */ '@/pages/HomeM')
        component: (resolve) => require(['@/pages/HomeM'], resolve),
        redirect: '/home',
        children: [
            {
                path: 'home',
                name: 'Home',
                component: (resolve) => require(['@/pages/Home'], resolve)
            },
            {
                path: 'del',
                name: 'Del',
                component: (resolve) => require(['@/pages/del'], resolve)
            }
        ]
    },
    // {
    //   path: '/video/:id',
    //   name: 'Video',
    //   component: (resolve) => require(['@/pages/Video'], resolve)
    // },
    {
        path: '/login',
        name: 'Login',
        component: (resolve) => require(['@/pages/Login'], resolve)
    },

]

const router = new VueRouter(
    {
        routes
    })

router.beforeEach((to, from, next) => {
    // let token = localStorage.getItem("token");
    // let decoded = null
    // let role = null
    let token = true;
    // let role = 0;
    // if (token) {
    // decoded = jwt_decode(token);
    // role = decoded.role
    // }
    // let pattern = /^\/admin\//

    if (to.path === '/login') {
        next();
    }
        // else if (pattern.test(to.path)) {
        //   if (!token || role != 1) {
        //     next('/admin/login');
        //   } else {
        //     next();
        //   }
    // }
    else {
        if (!token) {
            next('/login');
        } else {
            next();
        }
    }
})



const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router
